import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { ScheduleService } from 'src/app/service/schedule.service';
declare var $: any;
@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {

  showLoader: boolean = false;
  searched: boolean = false;
  slots: any;
  table: any;
  years: any;
  semesters: any;
  batches: any;
  orgId : any;
  schedules:any;
  yearId:any;
  semesterId:any;
  gradeId:any;
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),

    active: new FormControl(true, [
      // Validators.required,
    ]),
  });

  lectureScheduleSlots = new FormGroup({
  });

  constructor(private scheduleService:ScheduleService ,private toastrService: ToastrService, public globals: Globals, private router: Router,
    public translate: TranslateService, private enrollmentGroupService: EnrollmentGroupService) { }

  ngOnInit(): void {
    this.getYears();
    this.searched=false;
    this.orgId = this.globals.currentUserInfo.orgid;
    // this.schedules = [
    //   {
    //     id: "1",
    //     effectiveDateFrom: "2022-01-30",
    //     effectiveDateTo: "2022-02-25",
    //     status:"LOCK",
    //     active: "NO",
    //   },
    //   {
    //     id: "2",
    //     effectiveDateFrom: "2022-02-26",
    //     effectiveDateTo: "",
    //     status:"UNLOCK",
    //     active: "YES",
    //   },
    // ];
    this.updateTable();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
    this.showLoader=false;
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
       $(document).ready(function () {     
      $("#datatable").DataTable({
        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // pageLength: 5,
        lengthChange: false,
        paging: false,
        searching: false
      });
    }, 1);
  });
  }

  searchFormChange(){};
  searchFormSubmit(){
    if (this.searchForm.valid) {
      // this.creating = true;
      console.log("Submit search form values");
      console.log(this.searchForm.value);
      this.yearId = this.searchForm.controls.year.value;
      this.semesterId=this.searchForm.controls.semester.value;
      this.gradeId=this.searchForm.controls.batch.value;
      this.getAllScheduleHeaders(this.searchForm.controls.year.value,this.searchForm.controls.semester.value,this.searchForm.controls.batch.value, this.searchForm.controls.active.value);
      
    }
    else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
    
  };
  getAllScheduleHeaders(year:any,semester:any,batch:any, active: any) {
    let activeFlag = (active)? 'ACTIVE' : 'ALL';
    this.scheduleService.getAllScheduleHeaders(this.orgId,year,semester,batch, activeFlag)
      .subscribe(
        data => {
          this.schedules=data;
          this.updateTable();
          this.searched=true;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  isTouched(formControlName: string): boolean {
    return this.lectureScheduleSlots.get(formControlName)?.touched ? true : false;
  }

  isInvalid(formControlName: string): boolean {
    return this.lectureScheduleSlots.get(formControlName)?.invalid ? true : false;
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

}

